(function () {
  function wrapUnsupported(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var nodes = [];
    var n;
    while ((n = walker.nextNode())) {
      if (/[^A-Za-z0-9 ]/.test(n.nodeValue)) nodes.push(n);
    }
    nodes.forEach(function (node) {
      var text = node.nodeValue;
      var frag = document.createDocumentFragment();
      var re = /[^A-Za-z0-9 ]/g;
      var last = 0;
      var m;
      while ((m = re.exec(text))) {
        if (m.index > last) frag.appendChild(document.createTextNode(text.slice(last, m.index)));
        var span = document.createElement('span');
        span.style.fontFamily = "'Anton', sans-serif";
        span.textContent = m[0];
        frag.appendChild(span);
        last = m.index + 1;
      }
      if (last < text.length) frag.appendChild(document.createTextNode(text.slice(last)));
      if (node.parentNode) node.parentNode.replaceChild(frag, node);
    });
  }

  function processFooter() {
    document
      .querySelectorAll('.footer-content .menu__item a, .social-icons__icon-label')
      .forEach(wrapUnsupported);
  }

  function watchRecommendations() {
    document.querySelectorAll('product-recommendations').forEach(function (rec) {
      if (rec.dataset.cmBostonWatched) return;
      rec.dataset.cmBostonWatched = '1';
      var run = function () {
        var blocks = rec.querySelectorAll('.section-resource-list__content .text-block');
        if (blocks.length) {
          blocks.forEach(wrapUnsupported);
          return true;
        }
        return false;
      };
      if (!run()) {
        var mo = new MutationObserver(function () {
          if (run()) mo.disconnect();
        });
        mo.observe(rec, { childList: true, subtree: true });
      }
    });
  }

  function init() {
    processFooter();
    watchRecommendations();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
